export default {
    title_list: 'Categories',
    title_page: 'Category',
    title_create_page: 'Create category',
    title_edit_page: 'Change category',

    filter: {
        labels: {
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            slug: 'Slug',
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        slug: 'Slug',
        description: 'Description',
        seo_title: 'Seo title',
        seo_description: 'Seo description',
        seo_keywords: 'Seo keywords',
    },
}
